const LoadingSpinner = ({ 
  text = "Cargando...", 
  size = "md", 
  fullScreen = false,
  className = "" 
}) => {
  const sizes = {
    sm: "w-4 h-4",
    md: "w-8 h-8", 
    lg: "w-12 h-12"
  };

  const Component = (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div className={`border-2 border-gray-200 border-t-black rounded-full animate-spin ${sizes[size]}`}></div>
      {text && <p className="text-gray-600 text-sm font-medium">{text}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        {Component}
      </div>
    );
  }

  return Component;
};

export default LoadingSpinner; 